module.exports = __webpack_public_path__ + "img/step_1.83ea07a2.png";